import React, { useEffect, useState } from "react";
import { TopButs } from "./TopButs";
import { FormBox } from "./FormBox";
import { TableBox } from "./TableBox";
import { FixedBottom } from "./FixedBottom";
import { AddGoodsModal } from "./AddGoodsModal";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { Print } from "./Print";
import { AddTempShelfModal } from "./AddTempShelfModal";
import { BatchSelectWarehouseModal } from "./BatchSelectWarehouseModal";
import useGlobalModel from "@/model/globalModel";

export const PurchaseDrDetails = () => {
    const { getSelectedNavState } = useNavModel(() => []);
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);
    const { user: { roles } } = useGlobalModel();
    return (
        <>
            {/* <TopButs {...detailsInfo} /> */}
            <FormBox {...detailsInfo} />
            <TableBox {...detailsInfo} />
            {!roles.includes('hd-c' || 'hd-g') && <FixedBottom {...detailsInfo} />}
            <AddGoodsModal {...detailsInfo} />
            <AddGoodsModal {...detailsInfo} />
            <AddTempShelfModal />

            <Print />
        </>
    )
}